<template>
  <keep-alive>
    <b-modal
        :id="id"
        ref="modal"
        :title="modalTitle"
        no-close-on-backdrop
        title-class="font-18"
        v-bind="$attrs"
        @ok="handleOk"
    >
      <validation-observer v-if="!loading" ref="form_observer">
        <component
            :is="form"
            ref="form"
            v-model="model"
            :errors="errors"
            :is-valid.sync="isValid"
            is-modal="true"
            v-bind="formProps"
            v-on="formListeners"
        >
        </component>
      </validation-observer>
      <div v-if="loading" class="d-flex">
        <i class="bx bx-loader bx-spin font-size-16 align-middle mx-auto"></i>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <b-button size="md" variant="outline-dark" @click="cancel()">
          {{ $t('Cancel') }}
        </b-button>
        <b-button
            :disabled="updating || loading"
            size="md"
            variant="primary"
            @click="ok()"
        >
          <i
              v-if="updating"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i>
          {{ $t('Store') }}
        </b-button>
      </template>
    </b-modal>
  </keep-alive>
</template>

<script>
import ModelEditModal from "./modal-edit";
import FormsModel from "@/components/forms/odoo-obligor-limit.vue";
import MultiselectAjax from "@/components/inputs/vue-multiselect-ajax";
import {buildOdooObligorLimitGroupPayload} from "@/services/transformers/odooObligorLimitGroupPayload";

export default {
  extends: ModelEditModal,
  components: {
    MultiselectAjax,
  },
  props: {
    id: {type: String, required: true},
    modalTitle: {
      default() {
        return this.lodash.startCase(`${this.$t('Edit')} Group`);
      },
    },
    resourceRoute: {default: "models"},
    modelVariable: {default: "model"},
    form: {
      type: Object,
      default: function () {
        return FormsModel;
      },
    },
    formProps: {
      type: Object,
      default: function () {
        return {};
      },
    },
    formListeners: {
      type: Object,
      default: function () {
        return {};
      },
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      },
    },
    denyCustomerSelect: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      loading: false,
      isValid: true,
      updating: false,
      model: {
        ...this.initialValue,
        farms: [],
      },
      errors: {},
      registered:
          this.initialValue?.registered !== undefined
              ? this.initialValue.registered
              : true,
    };
  },
  methods: {
    async fetchModel(id = null) {
      try {
        this.loading = true;
        const response = await this.$axios.get(`/v1/obligor-limit-groups/${id}`);
        const {
          data: {data},
        } = response;
        this.$set(this, 'model', data);
        this.model = {
          ...data,
        };
        return response;
      } catch (error) {
        this.failedAlert(error);
      } finally {
        this.loading = false;
      }
    },
    update(value) {
      const payload = buildOdooObligorLimitGroupPayload(value);
      return this.$axios.put(`/v1/obligor-limit-groups/${value.id}`, payload);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .modal-title {
    font-weight: 800;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.05em;
    color: #0084f3;
  }

  .modal-dialog {
    max-width: 720px !important;
  }

  .col-form-label {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #6c7589;
  }
}
</style>
